/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuidIdAndLabel
 */
export interface GuidIdAndLabel {
    /**
     * 
     * @type {string}
     * @memberof GuidIdAndLabel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidIdAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GuidIdAndLabel
     */
    effective?: boolean;
}

export function GuidIdAndLabelFromJSON(json: any): GuidIdAndLabel {
    return GuidIdAndLabelFromJSONTyped(json, false);
}

export function GuidIdAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidIdAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function GuidIdAndLabelToJSON(value?: GuidIdAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'effective': value.effective,
    };
}


